// extracted by mini-css-extract-plugin
export default {"container":"GridSkeleton_container__26Hb-","fullH":"GridSkeleton_fullH__Dbzab","gridContainer":"GridSkeleton_gridContainer__M3yo+"};